// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Close_Wrapper__2az5A","Icon":"Close_Icon__1pr4e"};